import styled from 'styled-components';

export const ButtonContainer = styled.button`
  color: rgb(123, 115, 130);
  border: none;
  background-color: transparent;
  display: flex;
  align-items: center;
  gap: 3px;
  cursor: pointer;
`;

export const Icon = styled.img`
  width: 15px;
`;
